var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckGreen = function SvgIconCheckGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-green",
    transform: "translate(-153 -433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(153 433)",
    fill: "#4ac326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2355",
    "data-name": "Caminho 2355",
    d: "M16.629,21.35l-6.123,6.544L6.833,25,5.2,26.762l5.578,4.531,7.755-8.432Z",
    transform: "translate(153.098 418.808)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-check-green.d3554a31.svg";
export { ForwardRef as ReactComponent };